const mq = (query) => window.matchMedia(query).matches;
const isTouchDevice = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  if ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  const query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};
export {
  isTouchDevice
};
//# sourceMappingURL=is-touch-device.js.map
